var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(_setup.StoreSelector, {
            attrs: {
              stores: _setup.user.Stores,
              title: "Select store to retrieve POD information",
              "include-no-billing": "",
            },
            model: {
              value: _setup.storeUrl,
              callback: function ($$v) {
                _setup.storeUrl = $$v
              },
              expression: "storeUrl",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _setup.checkingProviders
        ? _c(
            "div",
            {
              staticClass:
                "col-12 align-items-center d-flex flex-column justify-content-center p-4",
            },
            [
              _c("b-spinner", {
                staticClass: "mr-2",
                attrs: { variant: "primary" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-2" }, [
                _vm._v("Checking providers"),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_setup.checkingProviders
        ? [
            _vm._l(_setup.providers, function (provider) {
              return _c(
                "div",
                {
                  key: `${provider.label}-${provider.key}`,
                  staticClass: "col-4",
                },
                [
                  _c(
                    "article",
                    {
                      staticClass: "card mb-2 image-resize",
                      staticStyle: { "object-fit": "cover" },
                    },
                    [
                      _c("img", {
                        staticClass: "card-img-top",
                        attrs: { src: provider.image, alt: provider.label },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _c("h4", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(provider.label)),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "card-text" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(provider.description) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _setup.isManualPod(provider.key)
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                on: {
                                  click: function ($event) {
                                    return _setup.podSelected(
                                      provider.key,
                                      provider.podId
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Set up manually\n                    "
                                ),
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                on: {
                                  click: function ($event) {
                                    return _setup.podSelected(
                                      provider.key,
                                      provider.podId
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Link\n                    "
                                ),
                              ]
                            ),
                      ]),
                    ]
                  ),
                ]
              )
            }),
            _vm._v(" "),
            !_setup.providers.length
              ? _c("div", { staticClass: "col-12 p-3 text-center" }, [
                  _vm._v("No POD providers available"),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }